import React from "react";

const BigCheck = () => (
  <svg width="27" height="27" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#10b981" strokeWidth="2" fill="none" />
    <path d="M8 12l3 3 5-6" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 2v9m0 0l-3-3m3 3l3-3M3 13h10" />
  </svg>
);

const SuccessCard = ({ data, collectedData }) => {
  if (!data) return null;

  const cardTitle = data.Title || data.title || "Transaction Complete!";
  const cardSubtitle = data.Subtitle || data.subtitle || "";
  const cardStats = data.Stats || data.stats || [];
  const qrUrl = data.QrCode || data.qrCode || "";
  const depositCode = data.Code || data.code || "";

  // ── PDF / file BlobUrl (e.g. SOA) ───────────────────────────────
  const blobUrl =
    data.downloadUrl ||
    data.DownloadUrl ||
    data.BlobUrl ||
    data.blobUrl ||
    (() => {
      try {
        const cd = typeof collectedData === "string" ? JSON.parse(collectedData) : collectedData;
        return cd?.BlobUrl || cd?.blobUrl || cd?.Download?.BlobUrl || "";
      } catch {
        return "";
      }
    })();

  // ── Excel base64 ────────────────────────────────────────────────
  const excelBase64 = (() => {
    const fromData = data.ExcelBase64 || data.excelBase64 || "";
    const fromName = data.ExcelFileName || data.excelFileName || "";
    if (fromData) return { base64: fromData, fileName: fromName || "statement.xlsx" };
    try {
      const cd = typeof collectedData === "string" ? JSON.parse(collectedData) : collectedData;
      return {
        base64: cd?.ExcelBase64 || cd?.excelBase64 || "",
        fileName: cd?.ExcelFileName || cd?.excelFileName || "statement.xlsx",
      };
    } catch {
      return { base64: "", fileName: "statement.xlsx" };
    }
  })();

  const qrImageUrl = qrUrl
    ? `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrUrl)}`
    : "";

  const filteredStats = cardStats.filter((s) => {
    const val = (s.Value || s.value || "").trim();
    return val && val !== "N/A" && val !== "-" && !val.includes("{");
  });

  const handleDownloadQr = async () => {
    try {
      const res = await fetch(qrImageUrl);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "deposit-qr.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch {}
  };

  const handleDownloadExcel = () => {
    try {
      const byteChars = atob(excelBase64.base64);
      const byteArray = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) byteArray[i] = byteChars.charCodeAt(i);
      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = excelBase64.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch {}
  };

  return (
    <div className="nav-card success-card-v2">
      <div className="sc2-header">
        <BigCheck />
        <strong>{cardTitle}</strong>
      </div>
      {cardSubtitle && <div className="sc2-subtitle">{cardSubtitle}</div>}
      {filteredStats.length > 0 && (
        <div className="sc2-stats">
          {filteredStats.map((s, i) => (
            <div key={i} className="sc2-stat">
              <small>{s.Label || s.label}</small>
              <strong>{s.Value || s.value}</strong>
            </div>
          ))}
        </div>
      )}

      {/* PDF / file download (BlobUrl) */}
      {blobUrl && !blobUrl.includes("{") && (
        <div className="sc2-download">
          <a href={blobUrl} target="_blank" rel="noopener noreferrer" className="sc2-download-btn">
            <DownloadIcon /> Download Statement
          </a>
        </div>
      )}

      {/* Excel download (base64) */}
      {excelBase64.base64 && (
        <div className="sc2-download">
          <button type="button" className="sc2-download-btn" onClick={handleDownloadExcel}>
            <DownloadIcon /> Download Excel
          </button>
        </div>
      )}

      {/* Deposit code (BOB Finance) */}
      {depositCode && !qrUrl && (
        <div className="sc2-code">
          <small>Deposit Code</small>
          <strong>{depositCode}</strong>
        </div>
      )}

      {/* QR code (Delivery Service) */}
      {qrImageUrl && (
        <div className="sc2-qr">
          <small>Show this QR to the cashier</small>
          <img src={qrImageUrl} alt="Deposit QR Code" className="sc2-qr-image" />
          <button type="button" className="sc2-qr-download" onClick={handleDownloadQr}>
            <DownloadIcon /> Download QR Code
          </button>
        </div>
      )}
    </div>
  );
};

export default SuccessCard;
